/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingResponseDto } from './SystemSettingResponseDto';
import {
    SystemSettingResponseDtoFromJSON,
    SystemSettingResponseDtoFromJSONTyped,
    SystemSettingResponseDtoToJSON,
    SystemSettingResponseDtoToJSONTyped,
} from './SystemSettingResponseDto';

/**
 * 
 * @export
 * @interface ListSystemSettingsResponseDto
 */
export interface ListSystemSettingsResponseDto {
    /**
     * 
     * @type {Array<SystemSettingResponseDto>}
     * @memberof ListSystemSettingsResponseDto
     */
    data: Array<SystemSettingResponseDto>;
}

/**
 * Check if a given object implements the ListSystemSettingsResponseDto interface.
 */
export function instanceOfListSystemSettingsResponseDto(value: object): value is ListSystemSettingsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListSystemSettingsResponseDtoFromJSON(json: any): ListSystemSettingsResponseDto {
    return ListSystemSettingsResponseDtoFromJSONTyped(json, false);
}

export function ListSystemSettingsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSystemSettingsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SystemSettingResponseDtoFromJSON)),
    };
}

export function ListSystemSettingsResponseDtoToJSON(json: any): ListSystemSettingsResponseDto {
    return ListSystemSettingsResponseDtoToJSONTyped(json, false);
}

export function ListSystemSettingsResponseDtoToJSONTyped(value?: ListSystemSettingsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SystemSettingResponseDtoToJSON)),
    };
}

